import React from "react";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import Metrics from "../parts/Metrics";
import Pillars from "../parts/Pillars";
import Invite from "../parts/Invite";
import brand from "../content/brand";

const Studio = () => (
  <Frame>
    <Meta title="Studio" description={`${brand.name} — a senior-led digital marketing studio based in ${brand.hq.city}, ${brand.hq.country}.`} />

    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Studio</div>
        <span className="eyebrow">Studio</span>
        <h1>A senior-led marketing studio, built around outcomes.</h1>
        <p className="lede">
          CMV Vision was set up by strategists and channel leads who got tired of seeing the same marketing engagements
          fail in the same predictable ways: drifting scope, channel-only thinking, junior teams running senior decisions,
          and dashboards built to flatter rather than inform.
        </p>
      </div>
    </section>

    <Metrics />

    <section className="band">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="eyebrow">Origin</span>
            <h2>Founded to do marketing properly for ambitious brands.</h2>
            <p>
              We work with a deliberately small portfolio of brands at any time, so that each engagement gets the senior
              attention it needs. Every engagement is owned end-to-end by a strategist or channel lead with at least
              ten years in the field.
            </p>
            <p>
              Our model is full-stack on purpose: strategy, brand, content, paid, SEO, social, growth, analytics, PR — all
              under one team. The relay race between agencies is where most marketing budget actually leaks. Closing
              that gap is the practice.
            </p>
            <p>
              We serve brands across DACH, the Balkans and the Middle East — and we operate bilingually in every market
              we run in.
            </p>
          </div>
          <div className="stat-card">
            <div className="big">Built <em>for</em> compounding</div>
            <div className="lbl">A studio designed to be operated against business KPIs your CFO already tracks. Senior on every account, in writing.</div>
          </div>
        </div>
      </div>
    </section>

    <section className="band band--soft">
      <div className="shell">
        <div className="section-title">
          <div className="left">
            <span className="eyebrow">Principles</span>
            <h2>Four commitments we put in writing.</h2>
          </div>
        </div>
        <Pillars />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Studio;
